import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { applyDefaultLanguage, hasExplicitLanguagePreference } from '../i18n';
import { URLS, SAGA_ACTIONS } from '.';
import { useAuthStatus, useIsForgotPassword } from '../store/selectors/userSelector';

const PrivateRoutes = () => {
    const isAuth = useAuthStatus();
    const isForgotPassword = useIsForgotPassword();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (isAuth) {
            dispatch({ type: SAGA_ACTIONS.USER.GET_MENUS, payload: {} });

            // Only consult the merchant's configured default language when this
            // browser has no explicit dropdown pick of its own -- checked live (not
            // frozen at module load) so a pick made on the login page's own language
            // selector, moments before this effect runs, is still honored. A passive
            // navigator-locale guess does not count and must not block the default.
            // applyDefaultLanguage re-checks at callback time too, in case the user
            // picks a language from the dropdown while this request is in flight.
            if (!hasExplicitLanguagePreference()) {
                dispatch({
                    type: SAGA_ACTIONS.SETTINGS_LANGUAGE.GET,
                    payload: {},
                    callbackSuccess: (response: any) => {
                        const languageCode = response?.data?.languageCode;
                        if (languageCode) {
                            applyDefaultLanguage(languageCode);
                        }
                    },
                    callbackError: () => {},
                });
            }
        }
    }, [isAuth, dispatch]);

    if (!isAuth) {
        return <Navigate to={URLS.AUTH.LOGIN} />;
    }

    if (isForgotPassword && location.pathname !== URLS.RESET_PASSWORD) {
        return <Navigate to={URLS.RESET_PASSWORD} replace />;
    }

    return <Outlet />;
}

export default PrivateRoutes;